import {Component, EventEmitter, Input, Output} from "@angular/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {PortableDevice} from "../json/portable-device";
import {PortableRegistrationService} from "../services/portable-registration.service";

@Component({
	selector: "portable-form",
	template: `
		<!---------- FORM GROUP ---------->
		<div [formGroup]="portableFormGroup">
			<div class="form_row">
				<div class="form_column form_column-50">

					<!---------- INPUT - SERIAL NUMBER ---------->
					<div class="form_field">
						<label for="deviceSerialNumber">Device Serial Number <span *ngIf="!deviceSerialNumber.valid">*</span></label>
						<input type="text" validPortableDevice [(ngModel)]="serialNum"
							id="deviceSerialNumber" formControlName="deviceSerialNumber"
							(input)="validateSerialNumber()">
						<form-errors [control]="deviceSerialNumber"></form-errors>
						<p class="form_helptext">Example: 1AB2345C</p>
					</div>
				</div>
			</div>

			<!---------- SEARCHING FOR PORTABLE DEVICE INFORMATION ---------->
			<div *ngIf="searchingForProduct" class="loading-indicator loading-indicator-no-margin">
				Searching for portable device information...
			</div>

			<!---------- PORTABLE DEVICE INFORMATION ---------->
			<ng-container *ngIf="portableDeviceMatches.length == 1; then singleDevice else selectDevice"></ng-container>
			<ng-template #singleDevice>
				<portable-registration-device-info [device]="portableDeviceMatches[0]"></portable-registration-device-info>
			</ng-template>
			<ng-template #selectDevice>
				<ng-container *ngIf="portableDeviceMatches.length > 1">
					<h3>Please select the correct device below.</h3>
					<div id="deviceSelector" *ngFor="let device of portableDeviceMatches">
						<div class="warrantyregistration_deviceinfo_selection"
							 (click)="setDevice($event, device)">
							<portable-registration-device-info [device]="device"></portable-registration-device-info>
						</div>
					</div>
				</ng-container>
			</ng-template>
		</div>
	`,
})
export class PortableRegistrationFormComponent {

	constructor(private portableRegistrationService: PortableRegistrationService) {}

	@Input() portableFormGroup: FormGroup;
	portableDevice: PortableDevice;
	portableDeviceMatches: Array<PortableDevice> = Array();
	@Output() portableDeviceEmitter = new EventEmitter<PortableDevice>();
	searchingForProduct: Boolean = false;
	serialNum: string;
	productSearchDebounce: NodeJS.Timer;
	productSearchDebounceSecondsMilli = 1500;

	static createFormGroup() {
		return new FormGroup({
			deviceSerialNumber: new FormControl(
				"", [
					Validators.required,
					Validators.pattern("[A-Z0-9]*"),
				]),
			});
	}

	get deviceSerialNumber() {
		return this.portableFormGroup.get("deviceSerialNumber");
	}

	validateSerialNumber() {
		if (this.productSearchDebounce) {
			clearTimeout(this.productSearchDebounce);
			this.productSearchDebounce = null;
		}
		this.portableDevice = null;
		this.portableDeviceEmitter.emit(null);
		if (this.deviceSerialNumber.value !== "") {
			this.searchingForProduct = true;
			this.productSearchDebounce = setTimeout(this.validateSerialNumberDebounce, this.productSearchDebounceSecondsMilli, this);
		}
		else {
			this.searchingForProduct = false;
		}
	}

	validateSerialNumberDebounce(portableRegistrationForm: PortableRegistrationFormComponent) {
		portableRegistrationForm.searchingForProduct = true;
		let serialNumber = portableRegistrationForm.deviceSerialNumber.value;
		if (serialNumber && serialNumber !== "") {
			portableRegistrationForm.portableRegistrationService
				.getPortableDevicesBySerialNumber(serialNumber).subscribe(portables => {
						if (portables.length == 1) {
							portableRegistrationForm.portableDeviceEmitter.emit(portables[0]);
						}
						portableRegistrationForm.portableDeviceMatches = portables;
						portableRegistrationForm.searchingForProduct = false;
				}, () => {
					portableRegistrationForm.searchingForProduct = false;
				});
		}
	}

	setDevice(event: Event, device: PortableDevice) {
		// Remove prior highlight
		let selections = document.getElementsByClassName("warrantyregistration_deviceinfo_selection");
		for (let device of Array.from(selections)) {
			(device as HTMLDivElement).style.border = null;
		}

		// Update currently selected device
		this.portableDeviceEmitter.emit(device);
		(event.currentTarget as HTMLDivElement).style.border = "5px solid #0071ce";
	}
}
